<template>
  <el-container class="admin-layout">
    <div class="mobile-header" v-if="isMobile">
      <el-button type="text" icon="el-icon-menu" @click="drawerVisible = true" class="menu-btn"></el-button>
      <span class="mobile-title">{{ headerTitle }}</span>
      <span class="header-user"><i class="el-icon-user"></i> {{ username }}</span>
    </div>

    <el-drawer
      v-if="isMobile"
      :visible.sync="drawerVisible"
      direction="ltr"
      size="220px"
      :show-close="false"
      :wrapperClosable="true"
    >
      <div class="drawer-aside">
        <div class="aside-header">
          <i class="el-icon-cpu"></i>
          <span>胡工后台管理</span>
        </div>
        <el-menu :default-active="$route.path" background-color="#1d1e1f" text-color="#bfcbd9" active-text-color="#409EFF" router @select="drawerVisible = false">
          <el-menu-item index="/admin">
            <i class="el-icon-document"></i>
            <span>文章管理</span>
          </el-menu-item>
          <el-menu-item index="/admin/edit">
            <i class="el-icon-edit"></i>
            <span>新增文章</span>
          </el-menu-item>
          <el-menu-item index="/admin/crawl">
            <i class="el-icon-search"></i>
            <span>爬虫管理</span>
          </el-menu-item>
        </el-menu>
        <div class="aside-footer">
          <el-button type="text" style="color:#bfcbd9;" @click="$router.push('/'); drawerVisible = false">
            <i class="el-icon-s-home"></i> 返回前台
          </el-button>
          <el-button type="text" style="color:#F56C6C;" @click="logout">
            <i class="el-icon-switch-button"></i> 退出登录
          </el-button>
        </div>
      </div>
    </el-drawer>

    <el-aside v-if="!isMobile" width="220px" class="admin-aside">
      <div class="aside-header">
        <i class="el-icon-cpu"></i>
        <span>胡工后台管理</span>
      </div>
      <el-menu :default-active="$route.path" background-color="#1d1e1f" text-color="#bfcbd9" active-text-color="#409EFF" router>
        <el-menu-item index="/admin">
          <i class="el-icon-document"></i>
          <span>文章管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/edit">
          <i class="el-icon-edit"></i>
          <span>新增文章</span>
        </el-menu-item>
        <el-menu-item index="/admin/crawl">
          <i class="el-icon-search"></i>
          <span>爬虫管理</span>
        </el-menu-item>
      </el-menu>
      <div class="aside-footer">
        <el-button type="text" style="color:#bfcbd9;" @click="$router.push('/')">
          <i class="el-icon-s-home"></i> 返回前台
        </el-button>
        <el-button type="text" style="color:#F56C6C;" @click="logout">
          <i class="el-icon-switch-button"></i> 退出登录
        </el-button>
      </div>
    </el-aside>

    <el-container class="admin-body">
      <el-header v-if="!isMobile" class="admin-header">
        <span class="header-title">{{ headerTitle }}</span>
        <span class="header-user"><i class="el-icon-user"></i> {{ username }}</span>
      </el-header>
      <el-main class="admin-main" :class="{ 'mobile-main': isMobile }">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'Admin',
  data() {
    return {
      isMobile: false,
      drawerVisible: false
    }
  },
  computed: {
    username() {
      return localStorage.getItem('username') || 'admin'
    },
    editId() {
      return this.$route.params.id
    },
    headerTitle() {
      const name = this.$route.name
      if (name === 'AdminEdit') return this.editId ? '编辑文章' : '新增文章'
      if (name === 'AdminCrawl') return '爬虫管理'
      return '文章管理'
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.admin-layout { height: 100vh; }
.admin-body { flex: 1; overflow: hidden; display: flex; flex-direction: column; }
.admin-aside {
  background: #1d1e1f;
  display: flex;
  flex-direction: column;
}
.aside-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #409EFF;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid #333;
}
.aside-header i { font-size: 22px; }
.aside-footer {
  margin-top: auto;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-top: 1px solid #333;
}
.admin-header {
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}
.header-title { font-size: 16px; font-weight: 600; color: #303133; }
.header-user { font-size: 14px; color: #909399; }
.admin-main { background: #f5f7fa; overflow-y: auto; }

.drawer-aside {
  background: #1d1e1f;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.drawer-aside .aside-header { color: #409EFF; }
.drawer-aside .aside-footer { border-top: 1px solid #333; }

.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  height: 50px;
  background: white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  flex-shrink: 0;
}
.menu-btn { font-size: 22px; color: #303133 !important; padding: 0; }
.mobile-title { font-size: 16px; font-weight: 600; color: #303133; }
.mobile-main { padding: 10px !important; }
</style>
